@if ({}; as STATE) {
  <section class="subscriber-channel-layout"></section>
}
